import { Component, Input, OnInit } from '@angular/core';
import { TaskCreationOperation } from 'app/modules/common/enums/task-create-operation-enum';

@Component({
    selector: 'app-task-creation-card',
    templateUrl: './task-creation-card.component.html',
    styleUrls: ['./task-creation-card.component.scss'],
    standalone: false
})
export class TaskCreationCardComponent implements OnInit {

    @Input() public LeaveId: number;
    @Input() public EmployeeId: number;
    @Input('task-create-operation') public taskOperation = TaskCreationOperation.Other;

    constructor() { }

    ngOnInit(): void {
    }

}
